import Api_Mec from "./Api_Mec";
import Util from "./Util";

class MEC_Calificaciones_api extends Api_Mec {
  constructor() {
    super();
  }

  insert(prmForm) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Calificaciones/insert",
      prmForm,
      {}
    );
  }

  delete_id(prmCriterio) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Calificaciones/delete_id",
      { id_plantilla: prmCriterio },
      {}
    );
  }

  calificar_plantilla(id_plantilla, calificado) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Calificaciones/calificar_plantilla",
      { id_plantilla: id_plantilla, calificado: calificado },
      {}
    );
  }

  reporte_x_plantilla(id_plantilla) {
    var util = new Util();

    this.get(
      this.url_api +
        "/MEC_API/MEC_Calificaciones/reporte_x_plantilla/" +
        id_plantilla,
      {}
    ).then((resp) => {
      util.saveByteArray(resp.data, "calificar_plantilla.xlsx");
    });
  }

  nro_calificaciones_plantilla(id_plantilla) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Calificaciones/nro_calificaciones_plantilla",
      { id_plantilla: id_plantilla },
      {}
    );
  }

  borrar_calificaciones_plantilla(id_plantilla) {
    return this.post(
      this.url_api +
        "/MEC_API/MEC_Calificaciones/borrar_calificaciones_plantilla",
      { id_plantilla: id_plantilla },
      {}
    );
  }

  async calificados_plantilla(id_plantilla) {
    let response;

    try {
      response = await this.post(
        this.url_api + "/MEC_API/MEC_Calificaciones/calificados_plantilla",
        { id_plantilla },
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }

  async calificado_plantilla_datos(id_plantilla, calificado) {
    let response;

    try {
      response = await this.post(
        this.url_api + "/MEC_API/MEC_Calificaciones/calificado_plantilla_datos",
        { id_plantilla, calificado },
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }

  async delete_calificado(id_plantilla, calificado) {
    let response;

    try {
      response = await this.post(
        this.url_api + "/MEC_API/MEC_Calificaciones/delete_calificado",
        { id_plantilla, calificado },
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }
}
export default MEC_Calificaciones_api;
